import React from 'react'
import Hero from '../components/CabinDetails/Hero'
import Steps from '../components/CabinDetails/Steps'
import Map from '../components/CabinDetails/Map'
import Brochure from '../components/Shared/Brochure'
import Design from '../components/CabinDetails/Design'
import NoUpsell from '../components/CabinDetails/NoUpsell'

const CabinDetails = () => {
  return (
    <div>
      <Hero />
      <Steps />
      <img src="/images/escapist__img.jpg" alt="" className='w-full object-cover' />
      <Map />
      <NoUpsell />
      <Design />
      <Brochure />
    </div>
  )
}

export default CabinDetails